import {  Navigate, Route, Routes } from "react-router-dom";
import Main from "../main";

const MainRoutes = () => {
    return (

        <Routes>
            <Route path="/"  element={<Navigate to="admin/" replace />} />
            <Route path="admin/*" element={<Main />} />
            {/* <Route path="dashboard/" element={<Main />} /> */}
            {/* <Route path="users/*" element={<Users />} /> */}
        </Routes>

    );
}
export default MainRoutes;